export default IconWindElectricity => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-wind-electricity" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M20 7l-3 5h4l-3 5" />
  <path d="M3 16h4a2 2 0 1 1 0 4" />
  <path d="M3 12h8a2 2 0 1 0 0 -4" />
  <path d="M3 8h3a2 2 0 1 0 0 -4" />
</svg>`;